import { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import React from 'react';
import Button from '../../components/button/index';
import VideoPlayer from '../../components/videoPlayer';
import Icon from '../../icon';
import useCoursePromotionPage from './styles';
import Countdown from 'react-countdown';
import { useTheme } from '../../theme/theming';
import calendar from '../../assets/images/calendar.svg';
import arrowRight from '../../assets/images/arrowRight.svg';
import PageContext from '../../contexts/pageContext';
import { formatCurrency } from '../../utils/currencyUtils';
import { wordBreakValue } from '../../utils/cssUtils';

const SingleVideoSlide = (props) => {
  const [isReadMore, setIsReadMore] = useState(false);
  const theme = useTheme();
  const {
    layout: { containerWidth },
    isMobile,
    isEdit
  } = useContext(PageContext);

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (days === 0 && hours < 24) {
      if (countryCode === 'KR') {
        return (
          <span>
            {hours} 시간 {minutes} 분 {seconds}초
          </span>
        );
      }
      return (
        <span>
          {hours}h {minutes}m {seconds}s
        </span>
      );
    } else {
      let given = moment(props.data.endDate);
      let current = moment().startOf('day');
      return (
        <span>
          {Math.floor(moment.duration(given.diff(current)).asDays())}{' '}
          {countryCode === 'KR' ? '일' : 'day(s)'}
        </span>
      );
    }
  };

  const {
    data,
    courseBuyNow,
    conversions = 20,
    showCourseInstallment,
    countryCode,
    currencySymbol
  } = props;

  const showCourseInstallmentData = data?.courseOverviewData;
  const InstalmentData = isEdit
    ? data?.courseOverviewData?.installments?.formData?.installments[0]
        .installmentAmount
    : data?.courseOverviewData?.installments?.formData?.installmentInfo
        ?.installments[0].installmentPrice;

  const checkIfOfferIsValid = () =>
    moment().diff(moment(props?.data?.endDate || 0)) < 0;

  const checkForShowDiscount = () => {
    if (props.data.endDate === null || checkIfOfferIsValid()) {
      if (data.discount > 0 && data.offerPriceValidFor === null) {
        return true;
      } else if (
        data.discount > 0 &&
        data.offerPriceValidFor !== null &&
        data.offerPriceValidFor - conversions <= 0
      ) {
        return false;
      }
    } else if (data.offerPriceValidFor >= null && data.discount) {
      if (data.offerPriceValidFor <= conversions) {
        return false;
      }
      if (data.offerPriceValidFor - conversions < 0) {
        return false;
      } else {
        return true;
      }
    }
    if (data.discount > 0) {
      return true;
    }
  };

  const classes = useCoursePromotionPage();
  const discount = ({ price, discount }) => {
    return ((discount / price) * 100).toFixed(2);
  };
  const renderHurryUpBannerText = () => {
    return countryCode === 'KR'
      ? `서두르세요! 현재 신청 가능 인원은 ${
          data.offerPriceValidFor - conversions
        }명 입니다.`
      : `Hurry up! Offer left for ${
          data.offerPriceValidFor - conversions
        } users now`;
  };
  const limitedPeriodOfferText =
    countryCode === 'KR'
      ? `기간 한정 딜이므로 서두르세요!`
      : 'Hurry up! Offer for limited period only';

  const renderOfferEndsInText = () => {
    if (countryCode === 'KR') {
      return (
        <p className={classes.offerText}>
          <span className={classes.courseDetailTime}>
            <Countdown renderer={renderer} date={data.endDate} />
          </span>{' '}
          후 신청 마감 예정
        </p>
      );
    } else {
      return (
        <p className={classes.offerText}>
          Offer Ends in{' '}
          <span className={classes.courseDetailTime}>
            <Countdown renderer={renderer} date={data.endDate} />
          </span>
        </p>
      );
    }
  };
  const effectivePrice = formatCurrency(
    countryCode,
    data?.effectivePrice,
    currencySymbol
  );
  const finalPrice = formatCurrency(countryCode, data?.price, currencySymbol);
  const buyNowText = countryCode === 'KR' ? '수강신청하기' : 'BUY NOW';

  const handleReadMoreText = () => {
    if (countryCode === 'KR') {
      return '더 보기';
    } else {
      return 'Read More';
    }
  };

  const handleCourseCertificateText = () => {
    if (countryCode === 'KR') {
      return '수료증 발급';
    } else {
      return 'Course Certificate';
    }
  };

  return (
    <div className={classes.videoCarouselContainer}>
      <div className={classes.coursePageCarousel}>
        <div className={classes.iframeSuperContainer}>
          <div className={classes.videoDetails}>
            {(checkIfOfferIsValid() || data.offerPriceValidFor > 0) &&
              (data.offerPriceValidFor > conversions ||
                data.offerPriceValidFor === null) && (
                <div>
                  {data.offerPriceValidFor - conversions > 0 &&
                  data.discount &&
                  (data.endDate ? checkIfOfferIsValid() : true) ? (
                    <div className={classes.bannerContainer}>
                      <div className={classes.bannerContainerText}>
                        {renderHurryUpBannerText()}
                      </div>
                    </div>
                  ) : (
                    checkIfOfferIsValid() && (
                      <div className={classes.bannerContainer}>
                        <div className={classes.bannerContainerText}>
                          {limitedPeriodOfferText}
                        </div>
                      </div>
                    )
                  )}
                </div>
              )}
            <div className={classes.emblemContainer}>
              {data?.courseOverviewData?.courseTagList.length &&
                data?.courseOverviewData?.courseTagList?.map((data) => {
                  return (
                    <div className={classes.courseEmblem}>{data?.text}</div>
                  );
                })}
            </div>
            <h3 className={classes.videoDetailsHeading}>
              <span
                ref={data?.videoTextHeading?.refSetter}
                dangerouslySetInnerHTML={{
                  __html: data.courseName
                }}
              />
            </h3>
            <div className={classes.courseDetailsTags}>
              {data?.courseOverviewData?.courseDuration?.text ? (
                <div className={classes.courseDetailTag}>
                  <span className={classes.iconBackground}>
                    <Icon
                      name={'Clock'}
                      width="24px"
                      color={theme?.colors?.background2}
                    />
                  </span>
                  <div>{data?.courseOverviewData?.courseDuration?.text}</div>
                </div>
              ) : null}
              {data?.courseOverviewData?.metaData?.isPhysicalDeliveryEnabled ? (
                <div className={classes.courseDetailTag}>
                  <span className={classes.iconBackground}>
                    <Icon
                      name={'Book Saved'}
                      color={theme?.colors?.background2}
                      width="24px"
                    />
                  </span>
                  <div>
                    {data?.courseOverviewData?.metaData
                      ?.isPhysicalDeliveryEnabled
                      ? 'Physical Books'
                      : null}
                  </div>
                </div>
              ) : null}

              {data?.courseOverviewData?.metaData?.isCertificateEnabled ? (
                <div className={classes.courseDetailTag}>
                  <span className={classes.iconBackground}>
                    <Icon
                      name={'Certificate'}
                      color={theme?.colors?.background2}
                      width="20px"
                    />
                  </span>
                  <div>
                    {data?.courseOverviewData?.metaData?.isCertificateEnabled
                      ? handleCourseCertificateText()
                      : null}
                  </div>
                </div>
              ) : null}

              {data?.courseOverviewData?.resourseDataText?.heading ? (
                <div className={classes.courseDetailTag}>
                  <span className={classes.iconBackground}>
                    <Icon
                      name={'Certificate'}
                      color={theme?.colors?.background2}
                      width="20px"
                    />
                  </span>
                  <div>
                    {data?.courseOverviewData?.resourseDataText?.heading}
                  </div>
                </div>
              ) : null}
            </div>
            <p
              ref={data?.videoTextContent?.refSetter}
              className={classes.courseDetailContent}
              dangerouslySetInnerHTML={{
                __html: isReadMore
                  ? data.description
                  : data.description.substring(0, 250)
              }}
            />
            <p
              onClick={() => {
                setIsReadMore(true);
              }}
              ref={data?.videoTextSubContent?.refSetter}
              className={classes.courseDetailViewFullDetails}
              dangerouslySetInnerHTML={{
                __html:
                  data.description.length > 250 && !isReadMore
                    ? handleReadMoreText()
                    : null
              }}
            />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div className={classes.courseViewContainer}>
            {checkIfOfferIsValid() &&
              (data.offerPriceValidFor !== null
                ? data.offerPriceValidFor - conversions > 0
                : true) &&
              renderOfferEndsInText()}
            <div
              ref={data?.videoFrame?.refSetter}
              className={classes.iframeContainer}
            >
              <VideoPlayer
                onlyThumbnail
                imageUrl={data.thumbnail}
                videoUrl={data.thumbnail}
                sectionIndex={props?.sectionIndex}
              />
            </div>
            <div className={classes.bottomContainer}>
              <div className={classes.priceContainer}>
                <div className={classes.offerPrice}>{effectivePrice}</div>
                {checkForShowDiscount() &&
                  (data.endDate ? checkIfOfferIsValid() : true) && (
                    <p
                      style={{
                        // fontSize: '20px',
                        marginTop: '0px'
                      }}
                    >
                      <span className={classes.originalPrice}>
                        {finalPrice}
                      </span>{' '}
                      <span className={classes.offerDiscount}>{`${
                        data && discount(data)
                      }%`}</span>
                    </p>
                  )}
              </div>
              <div>
                <Button
                  style={{
                    wordBreak: wordBreakValue(countryCode)
                  }}
                  data={{
                    // link: 'headerData?.loginCtaLink',
                    // isLink: 1,
                    value: buyNowText
                    // isExternal: 1
                  }}
                  onClick={courseBuyNow}
                  type={'primary'}
                  size={'medium'}
                  target={null}
                  name="button"
                  rel={null}
                  // styling={isMobile ? { margin: '0 40px' } : {}}
                />
              </div>
            </div>
          </div>
          {showCourseInstallmentData && InstalmentData && (
            <div
              className={classes.payInstallmentContainer}
              onClick={showCourseInstallment}
            >
              <img src={calendar} alt="calender" />
              <div className={classes.payInstallmentHeader}>
                <h4>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ` Start learning at Rs ${
                        isEdit ? InstalmentData : InstalmentData / 100
                      }`
                    }}
                  ></span>
                </h4>
                <p>Pay in Instalments</p>
              </div>
              <img
                className={classes.arrowRightIcon}
                src={arrowRight}
                alt="open pay-installment popup"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleVideoSlide;
